import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  dashboardData: [],
  dashboardBillingData: [],
  loading: false,
  error: null,
};

const dashboardSlice = createSlice({
  name: "dashboard",
  initialState,
  reducers: {
    fetchDashboardStart(state) {
      state.loading = true;
      state.error = null;
    },
    fetchDashboardSuccess(state, action) {
      state.dashboardData = action.payload.dashboardData;
      state.loading = false;
      state.error = null;
    },
    fetchDashboardFailure(state, action) {
      state.loading = true;
      state.error = action.payload;
    },
    fetchBillingDashboardStart(state) {
      state.loading = true;
      state.error = null;
    },
    fetchBillingDashboardSuccess(state, action) {
      state.dashboardBillingData = action.payload.dashboardBillingData;
      state.loading = false;
      state.error = null;
    },
    fetchBillingDashboardFailure(state, action) {
      state.loading = true;
      state.error = action.payload;
    },
    resetDashboard(state) {
      state.dashboardData = [];
      state.loading = false;
      state.error = null;
    },
  },
});

export const {
  fetchDashboardStart,
  fetchDashboardSuccess,
  fetchDashboardFailure,
  fetchBillingDashboardStart,
  fetchBillingDashboardSuccess,
  fetchBillingDashboardFailure,
  resetDashboard,
} = dashboardSlice.actions;

export default dashboardSlice.reducer;
